<h3 class="section-title">{{ 'Latest IFRS Foundation meetings'|translate }}</h3>
<div class="cards-container">

  @for (meeting of meetings(); track meeting) {
    <a [href]="getUrl(meeting.sourceUrl)">
      <app-latest-meeting-card
        [from]="meeting.startDate | onlyDate"
        [to]="meeting.endDate | onlyDate"
        [title]="meeting.title"
        [description]="meeting.summary || meeting.htmlDescription | removeHtml">
      </app-latest-meeting-card>
    </a>
  }

</div>

<app-see-all
  [showSeeAllButton]="meetings().length > 5"
  [url]="HELPER.getUrlFromMenu(E_FOLDER_TYPES.Meeting)"
  seeAllText="See all dates">
</app-see-all>
